export const globalStore = {
    idlogin: null,
    idusuario: null,
    idmunicipio: null,
    idipprestador: null,
    appname: 'SGOS-WEB',
    appver: '1.26.0601',
    ckadmin: 'N',
    ckipprestador: 'N',
    nmusuario: '',
    nmmunicipio: '',
    nmipprestador: '',

    ckpermitir_parcelar: 'N',
    cobr_prazo_inicial: 0,
    latitude: 0,
    longitude: 0,

    itensPorPagina: 15,

    perfil: {
        id: 0,
        agr_acesso: 0,
        gab_acesso: 0,
        gab_gestor: 0,
        gab_recepcao: 0,
        gab_su: 0,
        frota_acesso: 0,
        ip_acesso: 0,
        obras_acesso: 0,
        sis_admin: 0,
    },
};